import * as React from "react";
import { useEffect, useState } from "react";
import DoctorIcon from "../../resources/images/patients/doctor-icon.svg";
import PracticeIcon from "../../resources/images/patients/practice-icon.svg";
import "./AssignmentPanel.scss";
import EditAction from "../commons/components/action/EditAction";
import AssignmentModal from "./AssignmentModal";
import Practice from "../commons/model/Practice";
import Doctor from "../commons/model/Doctor";
import sfetch from "../commons/utils/super-fetch";
import LoadingSpinner from "../flow/utils/LoadingSpinner";
import AssignmentCard from "../commons/model/AssignmentCard";

interface AssignmentPanelProps {
  canEditDoctorAssignment: boolean;
  canEditPracticeAssignment: boolean;
  assignableDoctors: Doctor[];
  assignablePractices: Practice[];
  assignmentUrl: string;
  isConverted: boolean;
}

export default function AssignmentPanel({
  canEditDoctorAssignment,
  canEditPracticeAssignment,
  assignableDoctors,
  assignablePractices,
  assignmentUrl,
  isConverted,
}: AssignmentPanelProps) {
  const [displayModal, setDisplayModal] = useState(false);

  const [loading, setLoading] = useState(true);

  const [assignment, setAssignment] = useState<AssignmentCard | null>(null);

  useEffect(() => {
    loadAssignment();
  }, []);

  useEffect(() => {
    if (assignment !== null) {
      setLoading(false);
    }
  }, [assignment]);

  const loadAssignment = () => {
    setLoading(true);
    sfetch(assignmentUrl, {
      method: "GET",
    })
      .then((response) => response.json())
      .then((response) => {
        setAssignment(response);
      });
  };

  return (
    (loading && <LoadingSpinner></LoadingSpinner>) || (
      <>
        <div className="v-flex with-gap assignment-panel">
          <div className={"react-panel-title fullWidth assignment-title"}>
            <div className={"react-panel-title-container"}>
              {i18n["Page.PatientManagement.Assignment.Title"]}
            </div>
            {(canEditDoctorAssignment || canEditPracticeAssignment) && !isConverted && (
              <div className={"react-panel-title-action"}>
                <EditAction onClick={() => setDisplayModal(true)} />
              </div>
            )}
          </div>
          <div className="assignment">
            <div className="h-flex no-wrap with-small-gap flex-center">
              <img src={DoctorIcon} alt="doctor icon" />
              <span>{assignment.doctorName || i18n["Page.Patient.Not.Assigned"]}</span>
            </div>
          </div>
          <div className="assignment">
            <div className="h-flex no-wrap with-small-gap flex-center">
              <img src={PracticeIcon} alt="practice icon" />
              <span>{assignment.practiceName || i18n["Page.Patient.Not.Assigned"]}</span>
            </div>
          </div>
          {displayModal && (
            <AssignmentModal
              onClose={() => setDisplayModal(false)}
              onSave={() => {
                setDisplayModal(false);
                loadAssignment();
              }}
              canEditDoctorAssignment={canEditDoctorAssignment}
              canEditPracticeAssignment={canEditPracticeAssignment}
              assignment={assignment}
              assignableDoctors={assignableDoctors}
              assignablePractices={assignablePractices}
              assignmentUrl={assignmentUrl}
            />
          )}
        </div>
      </>
    )
  );
}
